import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiFilterLine, RiCheckFill } from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KenLoader from '../../../../Components/KenLoader/index';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/kenGridEditable';
import validator from 'validator';
// import '../../../../style/index.css';
import {
  getSeatingPlanData,
  postSeatingPlanData,
} from '../../../../Utils/apiServices';
import { sendMailSeatingPlan } from '../../../../Utils/sendMail';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'SEATING PLAN',
  },
];
export const facultyDropDown = [
  {
    label: 'Choose Room No',
    value: '--Select--',
  },
  {
    label: 'Room No. 101',
    value: 'Room No. 101',
  },
  {
    label: 'Room No. 102',
    value: 'Room No. 102',
  },
  {
    label: 'Room No. 103',
    value: 'Room No. 103',
  },
  {
    label: 'Room No. 104',
    value: 'Room No. 104',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',

    borderRadius: '20px',
    fontSize: '10px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    // color: '#505F79',
    color: '#505F79',

    background: 'rgba(196, 196, 196,0.2)',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',

      color: '#505F79',
      // border: '1px solid #02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#979797',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#F2994A',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Course',
    value: '--Select--',
  },
  {
    label: 'Course 1',
    value: '1',
  },
  {
    label: 'Course 2',
    value: '2',
  },
];

const selectOptionsProgram = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Date',
    value: '--Select--',
  },
  {
    label: 'Date 1',
    value: '1',
  },
  {
    label: 'Date 2',
    value: '2',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '--Select--',
  },
  {
    label: 'Duration 1',
    value: '1',
  },
  {
    label: 'Duration 2',
    value: '2',
  },
];
const selectOptionsBatch = [
  {
    label: 'Select Exam Type',
    value: '--Select--',
  },
  {
    label: 'Exam 1',
    value: '1',
  },
  {
    label: 'Exam 2',
    value: '2',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const filterOptions = (data, type) => {
  switch (type) {
    case 'course':
      let courseOP = [
        {
          label: 'Select Course',
          value: '--Select--',
        },
      ];
      const uniqueCourseOP = [...new Set(data.map((item) => item?.course))];
      uniqueCourseOP.forEach((el) => courseOP.push({ label: el, value: el }));
      return courseOP;
    case 'term':
      let termOP = [
        {
          label: 'Select Term',
          value: '--Select--',
        },
      ];
      const uniqueTermOP = [...new Set(data.map((item) => item?.term))];
      uniqueTermOP.forEach((el) => termOP.push({ label: el, value: el }));
      return termOP;
    case 'duration':
      let durationOP = [
        {
          label: 'Select Duration',
          value: '--Select--',
        },
      ];
      const uniqueDurationOP = [...new Set(data.map((item) => item?.duration))];
      uniqueDurationOP.forEach((el) =>
        durationOP.push({ label: el, value: el })
      );
      return durationOP;
    case 'exam':
      let examTypeOP = [
        {
          label: 'Select Exam Type',
          value: '--Select--',
        },
      ];
      const uniqueExamTypeOP = [
        ...new Set(data.map((item) => item?.exam_type)),
      ];
      uniqueExamTypeOP.forEach((el) =>
        examTypeOP.push({ label: el, value: el })
      );
      return examTypeOP;
    default:
      break;
  }
};

const SeatingPlan = () => {
  const [rows, setRows] = useState([]);
  const [rowsData, setrowsData] = useState([]);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [startTime, setStartTime] = useState('10: 45');
  const [previous, setPrevious] = useState({});
  const [linkState, setLinkState] = useState('Link');
  const [endDate, setEndDate] = useState('25-02-2022');
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  // filter options
  const [courseOptions, setCourseOptions] = useState();
  const [termOptions, setTermOptions] = useState();
  const [dateOptions, setDateOptions] = useState();
  const [durationOptions, setDurationOptions] = useState();
  const [examTypeOptions, setExamTypeOptions] = useState();
  const [filterData, setFilterData] = useState([]);
  //
  const [selectedDuration, setSelectedDuration] = useState();
  const [loading, setLoading] = useState(false);
  const [publishData, setPublishData] = useState(null);
  const validate = (value) => {
    if (validator.isURL(value)) {
      return true;
    } else {
      return false;
    }
  };
  const onToggleEditMode = (check, id, index) => {    
    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        if (row.id === id) {
          if (check === 'done') {
            setLoading(true);
            row.isEditMode = true;
            const payload = [
              {
                id: row.id,
                duration: row.duration,
                dateOfExam: row.date,
                timeOfExam: row.start_time,
                examType: row.exam_type,
                venue: 'Dubai',
                sendEmail:false
              },
            ];
            postSeatingPlanData(payload)
              .then((res) => {
                setLoading(false);              
                if (res.success === 'true' || true) {
                  // alert(res.message);
                  row.isEditMode = false;
                  setRows(newData);
                }
                row.isEditMode = false;
              })
              .catch((err) => {
                console.log('Failed to add. Please try again.',err);
                setLoading(false);
                row.isEditMode = false;
              });
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };
/* email send funcion */
useEffect(() => {
  if (publishData!==null) {
    console.log("publishData",publishData?.id);
    sendMailSeatingPlan(publishData?.id);
  }
}, [publishData]);
  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (check, id, index) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  const [selectedCourse, setSelectedCourse] = useState();
  const [selectedTerm, setSelectedTerm] = useState();
  const [selectValueProgram, setSelectValueProgram] = useState(
    selectOptionsProgram[0].value
  );
  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const [selectedExamType, setSelectedExamType] = useState(
    selectOptionsBatch[0].value
  );
  const handleCourseChange = (e) => {
    setSelectedCourse(e.target.value);    
  };

  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const handleTermChange = (e) => {
    setSelectedTerm(e.target.value);
  };

  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const handleExamTypeChange = (e) => {
    setSelectedExamType(e.target.value);
  };

  const handleDurationChange = (e) => {
    setSelectedDuration(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const manageStartDate = (e, row) => {
    setStartDate(e.target.value);
  };

  const manageStartTime = (e, row) => {
    setStartTime(e.target.value);
  };

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);
  const [filterKeyValue, setFilterKeyValue] = useState({});
  const getSeatingDatas = () => {
    setLoading(true);
    getSeatingPlanData()
      .then((res) => {
        setLoading(false);
        const SeatingInfo =
          res === null
            ? []
            : res.map((item, index) => {                
                return {
                  id: item.id,
                  course: item.course ? item.course : 'NA',
                  term: item.term ? item.term : 'NA',
                  candidates: item.numberOfCandidates
                    ? item.numberOfCandidates
                    : 'NA',
                  date: item.dateOfExam ? item.dateOfExam : 'NA',
                  start_time: item.startTimeOfExam
                    ? item.startTimeOfExam
                    : 'NA',
                  duration: item.duration ? item.duration : 'NA',
                  exam_type: item.examType ? item.examType : 'NA',
                  venue: item.venue ? item.venue : 'https://www.google.com/',
                  eligibleStudents: item.totalEligibleStudents
                    ? item.totalEligibleStudents
                    : 0,
                };
              });

        setRows(SeatingInfo);
        setrowsData(SeatingInfo);
        // setFilterDialog(false);
      })
      .catch((err) => {
        console.log('Seating Plan Data=>', err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getSeatingDatas();
  }, []);
  useEffect(() => {
    if (rows.length > 0 || !null) {
      setCourseOptions(filterOptions(rows, 'course'));
      setTermOptions(filterOptions(rows, 'term'));
      setDurationOptions(filterOptions(rows, 'duration'));
      setExamTypeOptions(filterOptions(rows, 'exam'));
    }
  }, [rows]);

  const getFilterData = (filter) => {
    const newData = [];   
    const users = rowsData.filter((item) => {
      for (let key in filter) {        
        if (item[key] === undefined || item[key] != filter[key]) {
          return item;
        }
      }
    });  
    //Term
    rows.map((item) => {
      if (item.term === selectedTerm) {
        newData.push(item);
      }
    });
    // course
    rows.map((item) => {
      if (item.course === selectedCourse) {
        newData.push(item);
      }
    });
    //Duration
    rows.map((item) => {
      if (item.duration === selectedDuration) {
        newData.push(item);
      }
    });
    //ExamType
    rows.map((item) => {
      if (item.exam_type === selectedExamType) {
        newData.push(item);
      }
    });

    setRows(newData);
  };
  useEffect(() => {
    if (
      selectedTerm ||
      selectedCourse ||
      selectedDuration ||
      selectedExamType
    ) {
      setFilterKeyValue({
        course: selectedCourse,
        duration: selectedDuration,
        term: selectedTerm,
        examType: selectedExamType,
      });
    }
  }, [selectedTerm, selectedCourse, selectedDuration, selectedExamType]);
  useEffect(() => {
    if (filterKeyValue) {
      getFilterData(filterKeyValue);
    }
  }, [filterKeyValue]);
  const handleResetFilter = () => {
    setFilterDialog((prevState) => !prevState);
    setRows(rowsData);
    // setSelectedTerm()
    // setSelectedCourse()
    // setSelectedDuration()
    // setSelectedExamType()
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Timetable & Seating Plan
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              style={{
                marginRight: '15px',
                background: '#979797',
                color: 'white',
                fontWeight: 'bold',
                textDecoration: 'none',
                textTransform: 'none',
              }}
              to={'#'}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead className={classes.tableHaderTitle}>
              <TableRow>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  COURSE
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  TERM
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  CANDIDATES
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  DATE
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  START TIME
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  DURATION
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  EXAM TYPE
                </TableCell>
                {/* <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  VENUE/LINK
                </TableCell> */}
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  EDIT
                </TableCell>
                <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="center"
                >
                  SEATING PLAN
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                let venueLink;                
                /* if (validate(row.venue_link)) {
                  venueLink = 'kenInput';
                } else if (row.venue_link == 'Generate') {
                  venueLink = 'kenSelect';
                } */
                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    <KenGridEditable
                      {...{
                        row,
                        onChange,
                        columns: [
                          {
                            column_name: 'course',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'term',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'eligibleStudents',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'date',
                            is_inline_edit: true,
                            inline_edit_type: 'kenDatePicker',
                          },
                          {
                            column_name: 'start_time',
                            is_inline_edit: true,
                            inline_edit_type: 'kenTime',
                          },
                          {
                            column_name: 'duration',
                            is_inline_edit: true,
                            inline_edit_type: 'kenInput',
                          },
                          {
                            column_name: 'exam_type',
                            is_inline_edit: true,
                            inline_edit_type: 'kenInput',
                          },
                          /* {
                            column_name: 'venue_link',
                            is_inline_edit: true,
                            inline_edit_type: venueLink,
                          }, */
                        ],
                      }}
                    />
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() =>
                              onToggleEditMode('done', row.id, index)
                            }
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert('revert', row.id, index)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="edit"
                          onClick={() =>
                            onToggleEditMode('edit', row.id, index)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"                            
                            className={classes.normal}
                            // to={`${routes.seatingPlan}/arrangement/${row.eligibleStudents}/${row.id}`}
                          >
                           <Link
                            className={classes.normal}
                            to={{
                              pathname: `${routes.seatingPlan}/arrangement`,
                              state: { data: row },
                            }}
                          >
                             Generate
                          </Link>
                          </Button>
                          <Button
                            variant="primary"
                            // component={Link}
                            className={classes.publishGenerate}
                            // to={`${routes.currentProgrammes}/${id}/details`}
                            onClick={()=>{
                              setPublishData(row)
                            }}
                          >
                            Publish
                          </Button>
                          
                        </div>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleResetFilter()}
        positiveButtonClick={() => handleFilterDialog()}
        positiveButtonText="Apply"
        negativeButtonText="Clear"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={courseOptions}
              value={selectedCourse}
              defaultValue={() => {
                return courseOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleCourseChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={termOptions}
              value={selectedTerm}
              defaultValue={() => {
                return termOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleTermChange}
              required
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsProgram}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid> */}
          {/*   <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Start Date"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Start Date"
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageStartDate}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Duration"
              options={durationOptions}
              value={selectedDuration}
              defaultValue={() => {
                return durationOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleDurationChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Type"
              options={examTypeOptions}
              value={selectedExamType}
              defaultValue={() => {
                return examTypeOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleExamTypeChange}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default SeatingPlan;
